"use client";

import { useEffect } from "react";
import {
  createAuthFlowErrorTracker,
  type AuthFlowErrorTrackerOptions,
} from "@/lib/auth-flow-error-tracker";

export type UseAuthFlowErrorTrackerOptions = Omit<
  AuthFlowErrorTrackerOptions,
  "pathname"
> & {
  pathname: string | null | undefined;
};

export function useAuthFlowErrorTracker(
  options: UseAuthFlowErrorTrackerOptions,
): void {
  const {
    pathname,
    sessionId,
    now,
    userAgent,
    webdriver,
    viewportWidth,
    getCaptchaContainerWidth,
    captureEvent,
    captureException,
    root,
    consoleObject,
    addErrorListener,
  } = options;

  useEffect(() => {
    const tracker = createAuthFlowErrorTracker({
      pathname,
      sessionId,
      now,
      userAgent,
      webdriver,
      viewportWidth,
      getCaptchaContainerWidth,
      captureEvent,
      captureException,
      root,
      consoleObject,
      addErrorListener,
    });
    tracker.start();
    return () => {
      tracker.stop();
    };
  }, [
    addErrorListener,
    captureEvent,
    captureException,
    consoleObject,
    getCaptchaContainerWidth,
    now,
    pathname,
    root,
    sessionId,
    userAgent,
    viewportWidth,
    webdriver,
  ]);
}
